<template>
    <transition name="fade" appear @after-enter="afterEnter">
        <div class="overlay fixed top-left bottom-right zi-1000">
            <transition name="slide" @after-leave="close">
                <div
                    v-if="slideContent"
                    class="fixed top-right white-bkg shadow bottom-0 flex flex-column"
                    :class="' sidepanel-' + size"
                >
                    <!-- LOADER -->
                    <preloader :display="loading" />
                    <!-- HEADER -->
                    <header class="pl-3 pr-7 py-4 white dark-blue-bkg">
                        <slot name="header"></slot>
                        <a
                            href="javascript:;"
                            class="white absolute top-4 right-3"
                            @click="slideContent = false"
                            ><i class="icon-close icon-16"></i
                        ></a>
                    </header>
                    <!-- BODY -->
                    <div class="p-3 flex-fill-column side-panel-content">
                        <slot name="content"></slot>
                    </div>
                    <!-- FOOTER -->
                    <div v-if="hasFooter" class="px-3 py-5 aright bt-1">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';

export default {
    props: {
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        size: {
            type: String,
            required: false,
            default: 'medium',
            validator: (val) => ['small', 'medium', 'large'].includes(val),
        },
    },

    data() {
        return {
            slideContent: false,
        };
    },

    created() {
        document.addEventListener('keyup', this.escape);
    },

    destroyed() {
        document.removeEventListener('keyup', this.escape);
    },

    computed: {
        hasFooter() {
            return true;
            return !!this.$slots['modal-footer'];
        },
    },

    methods: {
        close() {
            this.$emit('close');
        },
        afterEnter() {
            this.slideContent = true;
            this.$emit('afterEnter');
        },
        escape(event) {
            if (event.key === 'Escape') {
                this.slideContent = false;
            }
        },
    },

    components: {
        Preloader,
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';
.side-panel-content {
    overflow-x: hidden;
}
.overlay {
    background-color: rgba(0, 0, 0, 0.35);
}

.fade-enter-active,
.fade-leave-active,
.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s ease;
}

.slide-enter,
.slide-leave-to {
    transform: translateX(100%);
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.sidepanel-small {
    width: $sidepanel-small;
}
.sidepanel-medium {
    width: $sidepanel-medium;
}
.sidepanel-large {
    width: $sidepanel-large;
}
</style>
